import React from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import { searchDataWithGet, submitFormData } from "src/app-redux/common-actions";
import { Loader } from "src/components/atoms/Loader";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonCheckBox from "src/components/CommonCheckBox/CommonCheckBox";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: theme.typography.pxToRem(17),
      color: "#000",
      lineHeight: "28px",
    },
    marginLabelText: {
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "20px",
    },
    marginLabelHeading: {
      fontWeight: theme.typography.fontWeightRegular,
      color: "rgba(0, 0, 0, 0.54)",
      lineHeight: "20px",
    },
    termandconduction: {
      color: "red",
      fontStyle: "italic",
      fontSize: 12,
    },
  })
);
const quickPaydec = {
  "Opt-In":
    "By choosing to opt-in for <strong>Automatic QuickPay</strong> you consent to accept expedited payments at a discounted rate. TFG National agrees to issue payments within the selected terms for all </br> current, unpaid invoices and future invoices. There is no obligation to participate in this program, and the Master Service Agreement remains in full force. You may opt-out at any point.</br>Next Day Quick Pay is not available if your billing address is a P.O.box and will incur an overnight shipping charge of $35.00.",
  "Opt-Out":
    "By choosing to opt-out of your <strong>Automatic QuickPay</strong> selection your payment terms will revert to the terms described in your Master Service Agreement. Any existing,</br>approved unpaid invoices will not be modified from their previous QuickPay selection. You will have the option to manually select QuickPay on any future payments.",
};
type Props = {
  setIsQuickPaySetting: (status: boolean) => void;
  refrishGridData: () => void;
  settingData: any[];
};

export function QuickPaySetting({
  setIsQuickPaySetting,
  refrishGridData,
  settingData,
}: Props): React.ReactElement {
  const dispatch = useDispatch();
  const [loader, setLoader] = React.useState(false);
  const [currentSetting, setCurrentSetting] = React.useState<number>(0);
  const [currentSettingId, setCurrentSettingId] = React.useState<number>(0);
  const [currentSettingData, setCurrentSettingData] = React.useState<string>(
    "No QuickPay selection is currently selected"
  );
  const [selected, setSelected] = React.useState<boolean>(false);
  const [selectedQpPer, setSelectedQpPer] = React.useState<number>(0);
  const [quickPaySettingList, setQuickPaySettingList] = React.useState<any[]>([]);
  const classes = useStyles();
  React.useEffect(() => {
    initialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    if (settingData.length) getQuickpaysettingList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingData]);
  const initialData = async () => {
    setLoader(true);
    await getcurrentSetting();
    setLoader(false);
  };
  const getQuickpaysettingList = async () => {
    const qplist: any[] = [];
    settingData.map((item: any) => {
      qplist.push({
        value: item.id,
        label: `${item.percentage}% for ${item?.days === 1 ? "next day" : `${item?.days} days`} ${
          item?.fedexFee ? `($${item?.fedexFee} FedEx Fee)` : ""
        }`,
      });
    });
    setQuickPaySettingList(qplist);
  };

  const combineQuickPayData = (data: any) => {
    if (data?.qpPercentage > 0) {
      let dd = "";
      if (data?.qpsettingid === 1) {
        dd = `${data?.qpPercentage}% for next day ($${data?.fedexFee} FedEx Fee)`;
      } else {
        dd = `${data?.qpPercentage}% for ${data?.days} days ${
          data?.fedexFee ? `($${data?.fedexFee} FedEx Fee)` : ""
        }`;
      }
      setCurrentSettingData(dd);
    } else {
      let optOut = "No QuickPay selection is currently selected";
      if (data.optOutdate) {
        optOut = `No QuickPay selection is currently selected, last Opt-Out date: ${data.optOutdate}`;
      }
      setCurrentSettingData(optOut);
    }
  };
  const getcurrentSetting = async () => {
    try {
      const results: any = await dispatch(
        searchDataWithGet("/get-vendor-default-quickpay-setting/")
      );
      combineQuickPayData(results);
      setCurrentSettingId(results?.qpsettingid || 0);
      setCurrentSetting(results?.qpPercentage || 0);
      setIsQuickPaySetting(results?.qpPercentage > 0);
    } catch (error) {
      console.log(error);
    }
  };
  const saveCurrentSetting = async () => {
    setLoader(true);
    try {
      const body = {
        Option: !(currentSetting > 0),
        SettingId: selectedQpPer || currentSettingId,
      };
      const mgs =
        currentSetting > 0 ? "QuickPay successfully opted-out" : "QuickPay successfully opted-in";
      const results: any = await dispatch(
        submitFormData("/vendor-default-opt-quickpay-Update/", body, mgs)
      );
      if (results) {
        await getcurrentSetting();
        setSelected(false);
        setSelectedQpPer(0);
        refrishGridData && refrishGridData();
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const checkBtnStatus = () => {
    if (currentSetting > 0) {
      return !selected;
    } else {
      if (selectedQpPer && selected) return false;
      else return true;
    }
  };
  return (
    <>
      <Loader open={loader} />
      <Grid container direction="row">
        <Grid item xs={12} md={12}>
          <Box ml={0} mt={2.5} mb={2}>
            <Grid container direction="row">
              <Grid item xs={12} md={9}>
                <Box display={"flex"} mt={-0.6}>
                  <Box color="text.secondary">
                    <Typography className={classes.marginLabelHeading}>
                      Current Settings:
                    </Typography>
                  </Box>
                  <Box className={classes.marginLabelText} mt={0.2} ml={2} fontStyle={"italic"}>
                    {currentSettingData}
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                {currentSetting === 0 && (
                  <Box color="text.main" mt={-1} textAlign={"right"}>
                    <CommonAutoCompleteField
                      label="Select QuickPay Setting"
                      placeholder="Select QuickPay Setting"
                      optionsType={quickPaySettingList || []}
                      getOptionLabel={(option: any) => option.label || null}
                      required
                      onChange={(row: any) => {
                        setSelectedQpPer(row?.value || 0);
                      }}
                      value={
                        quickPaySettingList.find((ty: any) => ty.value === selectedQpPer) || null
                      }
                    />
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <Grid container direction="row">
            <Grid item xs={12} md={11}>
              <Box color="text.main" mt={currentSetting > 0 ? -1 : -2}>
                <Typography className={classes.marginLabelText}>
                  {" "}
                  <Box className={classes.marginLabelText} display="flex">
                    <CommonCheckBox
                      label={""}
                      name={"selected"}
                      value={selected}
                      handleChange={(e: any) => {
                        setSelected(e.target.checked);
                      }}
                      marginTop={currentSetting > 0 ? 0 : 1}
                      marginRight={-2}
                    />
                    <Box
                      fontSize={"10px"}
                      fontStyle="italic"
                      dangerouslySetInnerHTML={{
                        __html: currentSetting > 0 ? quickPaydec["Opt-Out"] : quickPaydec["Opt-In"],
                      }}
                    ></Box>
                  </Box>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={1}>
              <Box textAlign="right">
                <CommonButton
                  isGreen
                  disable={checkBtnStatus()}
                  onClick={() => {
                    saveCurrentSetting();
                  }}
                >
                  {currentSetting > 0 ? "Opt-out" : "Opt-in"}
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
